<!--
  +---------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     设备增值-收费方案详情-基本信息
  +---------------------------------------------------------------------------------------
-->

<template>
  <div v-loading="loading" class="ei-scheme-notice">
    <el-table
      ref="listTable"
      v-loading="loading"
      :data="list"
      :row-style="{ height: '59px' }"
      class="padding-mini"
      @row-click="clickRow">
      <el-table-column type="index" width="80" align="center" />
      <el-table-column label="通知时间" min-width="160">
        <template slot-scope="scope">
          {{ scope.row.des }}
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="100">
        <template slot-scope="scope">
          <span class="text-warning font-3x">
            <i v-if="scope.row.check" class="iconfont icon-tick"></i>
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getSchemeDetailApi, postSchemeApi } from '@/api/ei/eiApi'

export default {
  name: 'EiSchemeNotice',

  components: {
  },

  props: {
  },

  data() {
    return {
      loading: false,
      list: [],
      dialogShow: false,
      remind: [],
      remindGet: [],
      schemeid: this.$route.query.schemeid
        ? parseInt(this.$route.query.schemeid)
        : undefined,
    }
  },

  computed: {
  },

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.loading = true
      getSchemeDetailApi({ schemeid: this.schemeid }).then(res => {
        this.loading = false
        if (!res.errno) {
          this.remind = res.data.profile.remind ? res.data.profile.remind : []
          const arr = res.data.remind_type
          for (const v of arr) {
            if (this.remind.indexOf(v.id) > -1) {
              v.check = 1
            } else {
              v.check = 0
            }
          }
          const temp = {
            id: 0,
            des: '到期当天通知 (必选)',
            check: 1
          }
          arr.unshift(temp)
          this.list = arr
        }
      })
    },

    clickRow(row) {
      if (row.id) {
        row.check = row.check ? 0 : 1
        if (row.check) {
          this.remind.push(row.id)
        } else {
          this.remind.splice(this.remind.indexOf(row.id), 1)
        }
        const temp = {
          schemeid: Number(this.schemeid),
          remind: this.remind
        }
        postSchemeApi(temp).then(res => {
          if (!res.errno) {
            this.$message.success('通知方案设置成功！')
          } else {
            this.$message.error(res.message)
          }
        }).catch(() => {
        })
      }
    }
  }
}
</script>

<style lang="scss" slot-scoped>
.ei-scheme-notice {
  padding: 20px;
  .toolbox {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
